<template>
<div class="column is-half">
    <div class="group-video columns is-gapless">
        <div class="column">
            <div class="content">
                <star-series :series="item"></star-series>
                <h4>תוכנית אימונים</h4>
                <router-link :to="{name: 'videoSeries', params:{sid: item.id}}">
                  <h3>{{item.pagetitle}}</h3>
                </router-link>
                <hr>
                <current-tag v-for="current in currentList" :current="current"
                :base="$store.state.initialData.basepath" :key="current.id" class="s-current">
                </current-tag>
                <hr>
                <p>מספר שיעורים בתוכנית: {{videoList.length}}</p>

                <p>
                    <router-link v-for="teacher in teachers" :key="teacher.id"
                    :to="{name: 'teacherPage', params:{tid: teacher.id}}">
                    {{teacher.name}} |
                    </router-link>
                </p>
            </div>
        </div>
        <div class="column">
          <router-link :to="{name: 'videoSeries', params:{sid: item.id}}">
            <figure class="image is-square">
                <img :src="imgUrl" :alt="item.pagetitle">
            </figure>
          </router-link>
        </div>
    </div>
</div>
</template>

<script>
import CurrentTag from "@/components/CurrentTag.vue";
import StarSeries from "./StarSeries.vue";

export default {
  name: `GvItem`,
  components: {
    StarSeries,
    CurrentTag
  },
  props: {
    item: Object
  },

  computed: {
    imgUrl() {
      return this.$store.state.initialData.basepath + this.item.ch.trim();
    },
    teachers() {
      const output = {};
      if (Array.isArray(this.item.videoList)) {
        this.item.videoList.forEach((v) => {
          this.$store.state.initialData.teachers.forEach((t) => {
            if (t.id === v.videoTeacher) {
              output[t.id] = t;
            }
          });
        });
      }
      return Object.values(output);
    },
    videoList() {
      if (typeof this.item.videoList !== `undefined`) {
        return this.item.videoList;
      }
      return [];
    },

    currentList() {
      const arr = [];
      const output = [];
      this.videoList.forEach((video) => {
        if (arr.indexOf(video.current) === -1) {
          arr.push(video.current);
        }
      });

      arr.forEach((c) => {
        if (typeof this.getCurrent(c) !== `undefined`) {
          output.push(this.getCurrent(c));
        }
      });
      return output;
    }
  },

  methods: {
    getCurrent(current) {
      if (Array.isArray(this.$store.state.currents)) {
        const arr = this.$store.state.currents.filter((c) => {
          if (typeof c.resource !== `undefined` && c.resource.id === current) {
            return true;
          }
          return false;
        });

        return arr[0];
      }
      return {};
    }
  }
};
</script>

<style lang="scss">
$black: #191919;
.group-video {
  p {
    margin-bottom: 5px;
    a {
      color: $black;
      font-size: 12px;
    }
  }

  .s-current {
    font-size: 14px;
  }
}
</style>
